import React from "react";
import CrudPage from "./CrudPage";
export default function AdminTuk() {
  return <CrudPage title="TUK" endpoint="tuk" testPrefix="tuk" fields={[
    {key: "name", label: "Nama TUK"},
    {key: "type", label: "Jenis TUK"},
    {key: "city", label: "Kota"},
    {key: "address", label: "Alamat"},
    {key: "phone", label: "Telepon"},
    {key: "email", label: "Email"},
    {key: "photo_url", label: "URL Foto"},
  ]} />;
}
